import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedProject } from "@/store/slices/projectSlice";
import { RootState } from "@/store/store";
import { useNavigate, useLocation } from "react-router-dom";
import { IProject } from "@/interfaces/project.interface";

function useHandleNotificationClick() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const projects = useSelector((state: RootState) => state.projects.projects);

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let areaId = params.get("areaId");
    let levelId = params.get("levelId");
    let projectId = params.get("projectId");

    // If missing, check `localStorage` (app might have reloaded)
    if (!areaId || !levelId || !projectId) {
      const storedParams = JSON.parse(localStorage.getItem("pendingNotification") || "{}");
      areaId = storedParams.areaId;
      levelId = storedParams.levelId;
      projectId = storedParams.projectId;
    }

    if (areaId && levelId && projectId) {
      console.log("[Push] Handling deep link:", { areaId, levelId, projectId });

      const project = projects.find((p) => p.id === projectId);
      console.log("[Push] Project found:", project);

      if (!project) {
        console.warn("[Push] Project not found yet. Storing for later...");
        localStorage.setItem("pendingNotification", JSON.stringify({ areaId, levelId, projectId }));
        return;
      }

      dispatch(setSelectedProject(project as IProject));
      localStorage.removeItem("pendingNotification"); // Cleanup after handling
      navigate("/home");
      window.dispatchEvent(new CustomEvent("notification-clicked", { detail: { areaId, levelId, projectId } }));
      window.history.replaceState({}, document.title, "/home");
    }

  }, [location, projects]);
}

export default useHandleNotificationClick;
